// extracted by mini-css-extract-plugin
export var header = "header-module--header--m4O4n";
export var headerAnimation = "header-module--header__animation--+65XB";
export var headerContent = "header-module--header__content--X4Ze+";